export default "__VITE_ASSET__BhZAdU0t__"